import format from 'dateformat';
import {isNZLocale} from './PropertyUtils';

const AnalyticsGateway = {
  initialize: () => {
    const segmentKey = isNZLocale()
      ? window.ENV.SEGMENT_KEY_NZ
      : window.ENV.SEGMENT_KEY_AU;
    window.analytics &&
    window.analytics.load &&
    window.analytics.load(segmentKey);
  },

  /** @deprecated send the bare report type to sendEvent */
  reportDescription: (reportType) => {
    const reportTypeMappings = {
      soi: 'Statement of Information Report',
      cma: 'CMA Report',
      rental: 'Rental CMA Report',
    };
    return reportTypeMappings[reportType && reportType.toLowerCase()];
  },

  sendEvent: (data) => {
    const eventProperties = {};
    data.properties.forEach((property) => {
      eventProperties[property.label] = property.label === 'Report Type' ?
        AnalyticsGateway.reportDescription(property.value) || property.value :
        property.value;
    });
    window?.analytics?.track(data.eventName, {
      ...eventProperties,
    });
  },

  identifyUser: (data) => {
    const countryCode = isNZLocale() ? 'NZ' : 'AU';
    window.analytics.identify(
      data.username,
      {
        Site: `${countryCode} Signature`,
        'Site Version': '1',
        Username: data.username,
        Email: data.workEmail,
        '$email': data.workEmail,
        'First Name': data.firstName,
        'Last Name': data.lastName,
        'CRM Account ID': data.accountId,
        'Trade Name': data.tradeName,
        'Industry Segment': data.industrySegment,
        'Franchise ID': data.franchiseId,
        [`Date Last Used ${countryCode} Signature`]: format('isoUtcDateTime'),
      });
    window.analytics.ready(() => {
      /*eslint no-undef: 0*/
      mixpanel.people.set_once({
        [`Date First Used ${countryCode} Signature`]: format('isoUtcDateTime'),
      });
    });
  },

  pageView: (pathname) => {
    window.analytics.page({path: parsePath(pathname)});
  },

  addUserTraits: (data) => {
    const userTraits = {};
    data.traits.forEach((trait) => {
      userTraits[trait.label] = trait.value;
    });
    window.analytics.identify(
      data.username,
      {...userTraits}
    );
  },

  descriptiveFieldNames: {
    listingPrice: 'Listing Price',
    salePrice: 'Sale Price',
    firstAdvertisementPrice: 'First Listing',
    firstPublishedPrice: 'First Listing',
    latestAdvertisementPrice: 'Last Listing',
    latestPublishedPrice: 'Last Listing',
  }
};

export const parsePath = (pathname) => {
  pathname = pathname.replace(/\/properties\/(\d)*/, '/properties/:id');
  if (pathname === '') {
    return '/';
  }
  return pathname;
};

export default AnalyticsGateway;